export default "__VITE_ASSET__Dj2MBZYP__"